<template>
  <div class="row justify-content-center align-items-md-center">
    <div class="col-md-8">
      <div class="card full-height bg-ligth">
        <div class="card-header d-flex justify-content-between">
          <h3 class="pt-1">{{ lista_campos != '' ? 'Editar' : 'Criar' }} setor</h3>
          <div class="col-md-8 ">
                <treeselect
                 disabled
                  :multiple="false"
                  :options="lista_eventos"
                  placeholder="Selecione o evento..."
                  v-model="form.eventos_id"
                />
              </div>
        </div>
        <div class="card-body table-responsive">
          <form action="">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-md-12">Nome:*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.nome"
                    placeholder="Digite o nome..."
                />
              </div>
        
              <div class="col-md-4 pt-2">
                <label class="col-md-12">Quantidade:*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.quant"
                    placeholder="Digite a Quantidade..."
                />
              </div>
           
            </div>
              
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-md-12">Descrição:*</label>
                <input
                    required
                    type="text"
                    class="form-control"
                    v-model="form.descricao"
                    placeholder="Digite a Descricao..."
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-md-12 text-center">
                <button
                    @click.prevent="confirm(lista_campos == '' ? 'cria' : 'edita')"
                    class="btn btn-primary"
                    :disabled="verif"
                >
                  Salvar
                  <b-spinner
                      v-show="verif"
                      small
                      variant="dark"
                      type="grow"
                      label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {fireAlert} from "@/core/mixins/alertMessageMixin";
import EventoService from "@/core/services/evento.service"

export default {
  mixins: [fireAlert],
  data() {
    return {
      form: {
        nome: "",
        quant: "",
        descricao: null,
        status: 1,
        eventos_id: EventoService.getEventoId()
      },
      verif: false,
    };
  },
  computed: {
    lista_campos() {
      return this.$store.state.configEmpresa.lista_campos;
    },
    mensagem_alert() {
      return this.$store.state.setor.mensagem_alert
    },
    lista_eventos() {
      return  EventoService.getEventos().map((cat) => ({
        id: cat.id,
        label:  cat.id+ " - " + cat.nome_evento
      }));
    },
  },
  created() {
    this.preenxerCampos();
  },
  methods: {
    async confirm(tipo) {
      await this.$confirm({
        title: "Estas seguro?",
        message: `Esta ação ` + tipo + ` un Setor no sistema?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            if (tipo == "cria") this.create();
            if (tipo == "edita") this.update();
          }
        },
      });
    },
    async create() {
      this.verif = true;
      await this.$store.dispatch("setor/create_setor", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'setor'
      });
    },
    async update() {
      this.verif = true;
      await this.$store.dispatch("setor/update_setor", this.form);
      this.verif = false;
      this.fireAlert({
        ...this.mensagem_alert, routeName: 'setor'
      });
    },
    preenxerCampos() {
      if (this.lista_campos != '')
        this.form = {
          id: this.lista_campos.id,
          nome: this.lista_campos.nome,
          descricao: this.lista_campos.descricao,
          status: this.lista_campos.status,
          quant: this.lista_campos.quant,
          eventos_id: this.lista_campos.eventos_id ?this.lista_campos.eventos_id :EventoService.getEventoId()


        };
    },
  },
};
</script>

<style scoped>
.lista:hover {
  background-color: #8cdde2;

}
</style>